import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BotApi from 'api/bot';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import SectorSelect from 'components/bots/SectorSelect';
import NotificationHelper from 'helpers/NotificationHelper';

const BotAboutForm = ({ bot }) => {
  bot.sector = bot.sector || bot.sectors[0] || {};
  bot.sector.label = bot.sector.name;
  bot.sector.value = bot.sector.id;

  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [sector, setSector] = useState(bot.sector);

  if (!bot) {
    return null;
  }

  const onSubmit = async e => {
    e.preventDefault();

    const form_instance = new FormData(e.target);
    const form_entries = Object.fromEntries(form_instance);

    form_entries.sector_id = sector.value;

    try {
      setSaving(true);
      await BotApi.update(bot.id, form_entries);
      NotificationHelper.successUpdate();
    } finally {
      setSaving(false);
    }
  };

  const onSectorChange = option => {
    setSector(option);
  };

  const renderDescriptionInputs = () => {
    return (
      <>
        <div className="form-group">
          <label htmlFor="inputName">Nome:</label>
          <input
            type="text"
            disabled={saving}
            className="form-control"
            defaultValue={bot.name}
            name="name"
            placeholder="Informe o nome do bot"
            required
          />
        </div>

        <div className="form-group mt-3 mb-4">
          <label htmlFor="inputEmail">Descrição:</label>
          <textarea
            disabled={saving}
            className="form-control"
            defaultValue={bot.description}
            name="description"
            placeholder="Descreva a tarefa executada pelo bot"
            required
          />
        </div>
      </>
    );
  };

  return (
    <form className="card" onSubmit={onSubmit}>
      <div className="card-body">
        <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('bots.config.about.title')}</h6>
        <hr />

        {!bot.is_customized ? null : renderDescriptionInputs()}

        <div className="form-group mt-3 mb-4">
          <label htmlFor="selectsector">Setor:</label>
          <SectorSelect value={sector} onChange={onSectorChange} isDisabled={saving} />
        </div>

        <hr />
        <div className="form-group mb-4 mt-4">
          <SubmitButton loading={saving} className="btn btn-primary" />
        </div>
      </div>
    </form>
  );
};

export default withRouter(BotAboutForm);
